<template>
    <SectionViewLayout
      title='settings.filters.titles.list'
      :content_state='content_state'
      content_class="settings-content-list"
      close_route="settings"
    >
        <template #actions>
            <ActionButton
                @click="onSearchToggle()"
                v-tooltip='"settings.filters.actions.search"'
                icon='fas fa-search'
                :class="{'active' : search_active}"
            />

            <ActionButton v-if='disable_add === false'
                @click="onFilterAdd()"
                v-tooltip='"settings.filters.actions.add"'
                icon="fas fa-plus-circle"
            />
        </template>

        <template #pre_content>
            <InputSearch v-if="search_active"
                ref="input_search_component"
                class="contacts-search"
                @inputSearchSet='onInputSearchSet'
                @InputSearchClear='onInputSearchClear'
            />
        </template>

        <template #content>
                <form>
                    <fieldset v-if="AccountController.account.premium.upgrade && disable_add">
                        <PremiumSubscribe
                            :text="Language.say('settings.filters.premium.upgrade_message', [AccountController.account.cos.max_sieve_filters])"
                            :gtm="{
                                module : 'filters_settings',
                                feature: 'filters_list',
                                block  : 'pre_content',
                                action : 'premium_subscribe'
                            }"
                        />
                    </fieldset>

                    <fieldset class="bottom-space">
                        <p>
                            {{ Language.say('settings.filters.content.inbox_filters') }}
                        </p>

                        <ContainerAlert
                            :type="(disable_add) ? 'warning' : 'info'"
                        >
                            {{Language.say('settings.filters.notices.usage_1')}}
                            <strong> {{ filters_list.count }}</strong> {{Language.say('settings.filters.notices.usage_2')}}
                            <strong> {{  AccountController.account.cos.max_sieve_filters }}</strong> {{Language.say('settings.filters.notices.usage_3')}}
                        </ContainerAlert>

                        <div class="top-space control-group" v-if="filters_list.count">
                            <div class="control item-list">
                                <div class="item">
                                    <span>
                                        {{ Language.say("settings.filters.labels.title") }}
                                    </span>
                                    <span>
                                        {{ Language.say("settings.filters.labels.status") }}
                                    </span>
                                </div>

                                <SmartList
                                    @smartListItemsSet=onSmartListItemsSet
                                    :smart_list_items="filters_list.items"
                                    >
                                    <template #elements>
                                        <div v-for="(item, index) in smart_list_items"
                                            :key="index"
                                            class="item"
                                        >
                                            <span role="button" @click="onFilterClick(item.id)">
                                                {{item.name}}
                                            </span>
                                            <span>
                                                <InputToggle
                                                    :id="'fl_tg_' + index"
                                                    :active="item.enabled"
                                                    @click.prevent="onFilterToggle(item)"
                                                    :loading="enable_loading_list[item.id]"
                                                />
                                            </span>
                                        </div>
                                    </template>
                                </SmartList>
                            </div>
                        </div>

                        <div class="top-space"  v-else>
                            <p>{{Language.say('settings.filters.no_filters')}}</p>
                        </div>
                    </fieldset>
                </form>

        </template>
    </SectionViewLayout>
</template>

<script setup>
    import { ref, defineProps, onBeforeMount } from 'vue';
    import { useRouter }                       from 'vue-router';
    import ActionButton                        from '@/vue/Elements/Buttons/ActionButton.vue';
    import SectionViewLayout                   from '@/vue/Layouts/Sections/SectionViewLayout.vue';
    import Language                            from '@/js/Shared/Language/Language';
    import ContainerAlert                      from '@/vue/Elements/Content/ContainerAlert.vue';
    import AccountController                   from '@/js/Webmail/AccountController';
    import PremiumSubscribe                    from '../../Webmail/Partials/Premium/PremiumSubscribe.vue';
    import InputToggle                         from '@/vue/Elements/Inputs/InputToggle.vue';
    import SmartList                           from '@/vue/Elements/Tools/SmartList.vue';
    import InputSearch                         from '@/vue/Elements/Inputs/InputSearch.vue';

    const props = defineProps({
        filters_controller : {},
        content_state      : {},
    })

    const route               = useRouter();
    const enable_loading_list = ref({})
    const disable_add         = ref(false);
    const smart_list_items    = ref();
    const search_active       = ref(false);
    const filters_list        = ref({});

    onBeforeMount(() => {
        setDisableAdd();
        setFiltersList();
    })

    const onFilterAdd = () => {
        route.push('/settings/filters/add');
    }

    const onFilterClick = (id) => {
        route.push('/settings/filters/edit/' + id);
    }

    const onFilterToggle = async ( filter ) => {
        if(enable_loading_list.value[filter.id]) {
        return
        }

        enableLoadingListSetValue(filter.id)
        await props.filters_controller.toggleFilterEnable(filter)
        enableLoadingListDeleteByIndex(filter.id)
    }

    const onSmartListItemsSet = (items) => {
        setSmartListItems(items);
    }

    const onInputSearchSet = (search_value) => {
        props.filters_controller.data.filters.search(search_value);
        setSearchList();
    }

    const onInputSearchClear = () => {
        props.filters_controller.data.filters.search_list.reset();
        setFiltersList();
    }


    const onSearchToggle = () => {
        search_active.value = !search_active.value;
    }

    const enableLoadingListSetValue = (value) => {
        enable_loading_list.value[value] = value;
    }

    const enableLoadingListDeleteByIndex = ( value ) => {
        delete enable_loading_list.value[value];
    }

    const setSmartListItems = (items) => {
        smart_list_items.value = items;
    }

    const setFiltersList = () => {
        filters_list.value = props.filters_controller.data.filters;
    }

    const setSearchList = () => {
        filters_list.value = props.filters_controller.data.filters.search_list;
    }


    const setDisableAdd = () => {
        if (props.filters_controller.data.filters.count >= AccountController.account.cos.max_sieve_filters) {
            disable_add.value = true;
            return;
        }

        disable_add.value = false;
    }
</script>